import apiClient from "./axios-client";

/**
 * saveStampStock
 * @returns
 */
export const saveStampStock = async (body) => {
  const response = await apiClient.post(
    `receipt/create-revenue-stamp-register`,
    body
  );
  return response.data;
};

export const zoneWiseStampStock = async(ZoneName) => {
  const response = await apiClient.get(
    `receipt/getZoneWiseStampStock?zonename=${ZoneName}`
  );
  return response.data
}

/**
 * Get getStampStockReport
 * @returns
 */
export const getStampStockReport = async (body) => {
  const response = await apiClient.post(
    `receipt/revenue-stamp-register-report`,
    body
  );
  return response.data;
};

/**
 * Get getZoneWiseReceiptReport
 * @returns
 */
export const getZoneWiseReceiptReport = async (body) => {
  const response = await apiClient.post(
    `receipt/getZonewiseReceiptReport`,
    body
  );
  return response.data;
};
